import React from 'react';
import ReactDOM from 'react-dom';
import { PootsyTitle } from "../DesignFunctions"

const modalRoot = document.getElementById('modal');
const stopEvents = e => e.stopPropagation()

class ModalLayout extends React.Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
	}

	componentDidMount() {
		modalRoot.appendChild(this.el);
	}

	componentWillUnmount() {
		modalRoot.removeChild(this.el);
	}

	render() {
		return ReactDOM.createPortal(
			<div className={"ModalLayout " + this.props.customClass} onClick={this.props.closeModal}>
				<div className="modal" onClick={stopEvents}>
					<PootsyTitle title={this.props.title}/>
					<div className={this.props.contentClass}>
						{this.props.children}
					</div>
					{this.props.buttons && <div className="buttons">{this.props.buttons}</div>}
				</div>
			</div>,
			this.el,
		);
	}
}

export default ModalLayout;


// WEBPACK FOOTER //
// ./src/components/shared/ModalLayout.js